/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateGlobalRemoteSessionClientForm,
  UpdateGlobalRemoteSessionClientForm$Outbound,
  UpdateGlobalRemoteSessionClientForm$outboundSchema,
} from "../components/updateglobalremotesessionclientform.js";

export type UpdateGlobalRemoteSessionClientSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type UpdateGlobalRemoteSessionClientRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  updateGlobalRemoteSessionClientForm: UpdateGlobalRemoteSessionClientForm;
};

/** @internal */
export type UpdateGlobalRemoteSessionClientSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpdateGlobalRemoteSessionClientSecurity$outboundSchema:
  z.ZodMiniType<
    UpdateGlobalRemoteSessionClientSecurity$Outbound,
    UpdateGlobalRemoteSessionClientSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function updateGlobalRemoteSessionClientSecurityToJSON(
  updateGlobalRemoteSessionClientSecurity:
    UpdateGlobalRemoteSessionClientSecurity,
): string {
  return JSON.stringify(
    UpdateGlobalRemoteSessionClientSecurity$outboundSchema.parse(
      updateGlobalRemoteSessionClientSecurity,
    ),
  );
}

/** @internal */
export type UpdateGlobalRemoteSessionClientRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  UpdateGlobalRemoteSessionClientForm:
    UpdateGlobalRemoteSessionClientForm$Outbound;
};

/** @internal */
export const UpdateGlobalRemoteSessionClientRequest$outboundSchema:
  z.ZodMiniType<
    UpdateGlobalRemoteSessionClientRequest$Outbound,
    UpdateGlobalRemoteSessionClientRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      updateGlobalRemoteSessionClientForm:
        UpdateGlobalRemoteSessionClientForm$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        updateGlobalRemoteSessionClientForm:
          "UpdateGlobalRemoteSessionClientForm",
      });
    }),
  );

export function updateGlobalRemoteSessionClientRequestToJSON(
  updateGlobalRemoteSessionClientRequest:
    UpdateGlobalRemoteSessionClientRequest,
): string {
  return JSON.stringify(
    UpdateGlobalRemoteSessionClientRequest$outboundSchema.parse(
      updateGlobalRemoteSessionClientRequest,
    ),
  );
}
